var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var _a;
import GenericPopup from "@frameworks/shared-library/components/GenericPopup";
import "@frameworks/salesjourney/stylesheets/components/Features/ActivityBook/RM_Orderbook/common/MFOrderbookCalendarFilter/MFOrderbookCalendarFilter.scss";
import React, { useEffect, useState } from "react";
import GenericDateSelectorModal from "@frameworks/shared-library/components/GenericDateSelector/GenericDateSelectorModal/GenericDateSelectorModal";
import moment from "moment";
import { nanoid } from "nanoid";
import { useReportZIndex as useCustomZindex } from "@frameworks/web/components/generic/customHooks/useOutSideClick";
export var inceptionDate = new Date("2015-04-01"); // April 1st, 2015
export var EMFOrderbookCalendarItems;
(function (EMFOrderbookCalendarItems) {
    EMFOrderbookCalendarItems["THIS_MONTH"] = "This Month";
    EMFOrderbookCalendarItems["LAST_MONTH"] = "Last Month";
    EMFOrderbookCalendarItems["THIS_QUARTER"] = "This Quarter";
    EMFOrderbookCalendarItems["LAST_QUARTER"] = "Last Quarter";
    EMFOrderbookCalendarItems["TILL_DATE"] = "Till Date";
    EMFOrderbookCalendarItems["YEARLY"] = "Yearly";
    EMFOrderbookCalendarItems["CUSTOM"] = "Custom Date Range";
})(EMFOrderbookCalendarItems || (EMFOrderbookCalendarItems = {}));
var getYearlySubGroups = function () {
    var currentDate = new Date();
    var currentYear = currentDate.getFullYear();
    // If the current date is before April 1st, adjust the current year to the previous year
    if (currentDate.getMonth() < 3 ||
        (currentDate.getMonth() === 3 && currentDate.getDate() < 1)) {
        currentYear -= 1;
    }
    var yearlySubgroups = [];
    for (var year = currentYear; year >= inceptionDate.getFullYear(); year--) {
        yearlySubgroups.push({
            label: "FY ".concat(year, "-").concat(year + 1),
            start: new Date(year, 3, 1),
            end: new Date(year + 1, 3, 0), // March 31st of the next year
        });
    }
    return yearlySubgroups;
};
var subGroups = (_a = {},
    _a[EMFOrderbookCalendarItems.YEARLY] = getYearlySubGroups(),
    _a[EMFOrderbookCalendarItems.THIS_MONTH] = [],
    _a[EMFOrderbookCalendarItems.LAST_MONTH] = [],
    _a[EMFOrderbookCalendarItems.THIS_QUARTER] = [],
    _a[EMFOrderbookCalendarItems.LAST_QUARTER] = [],
    _a[EMFOrderbookCalendarItems.TILL_DATE] = [],
    _a[EMFOrderbookCalendarItems.CUSTOM] = [],
    _a);
var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];
/**
 * MFOrderbookCalendarFilter
 *
 * This component is the part of Filter section on orderbook screens
 * Focusing on date ranges, this component give an ability to select filters as per the below list
 * [This month, Last month, This Quarter, Last Quarter, Till Date, Yearly, Custom Range]
 * Custom Range open up a calendar view to selected From and To dates
 *
 * @param {Function} handleFilterChangeCallback - Callback function to update payload with latest filter values
 * @param {Function} handleApplyCallback - Callback function to apply selected filter values
 * @param {T} filtersData- on top of Profile image (Eg: to display transaction type icon ie; STP/SWP)
 * @returns {}
 */
var uniqueCalendarFilterId = nanoid();
var MFOrderbookCalendarFilter = function (props) {
    var _a, _b;
    var _c = __read(useState([]), 2), subGroupsList = _c[0], setSubGroupsList = _c[1];
    var _d = __read(useState(), 2), selectedFilter = _d[0], setSelectedFilter = _d[1];
    var _e = __read(useState(false), 2), showCalendarFilterPopup = _e[0], setShowCalendarFilterPopup = _e[1];
    var _f = __read(useState(false), 2), showCustomCalendar = _f[0], setShowCustomCalendar = _f[1];
    var _g = __read(useState(""), 2), dpDate = _g[0], setDpDate = _g[1];
    // const uniqueCalendarFilterId = nanoid();
    var handleApplyOnCustomCalendar = function (date) {
        if (Array.isArray(date)) {
            var _a = __read(date, 2), startDate = _a[0], endDate = _a[1];
            handleApplyOnCalendarFilter(startDate, endDate);
        }
        setShowCustomCalendar(false);
    };
    useCustomZindex(showCustomCalendar, "collapsed-sidebar", "-2", "2");
    var handleClickOnCalendarFilter = function (label) {
        setSelectedFilter(label);
        if (subGroups[label].length > 0) {
            setSubGroupsList(subGroups[label]);
            return;
        }
        setSubGroupsList([]);
        if (label === EMFOrderbookCalendarItems.CUSTOM) {
            setShowCustomCalendar(true);
            setShowCalendarFilterPopup(false);
            return;
        }
        var startDate = moment();
        var endDate = moment();
        switch (label) {
            case EMFOrderbookCalendarItems.THIS_MONTH:
                startDate = moment().startOf("month");
                break;
            case EMFOrderbookCalendarItems.LAST_MONTH:
                startDate = moment().subtract(1, "months").startOf("month");
                endDate = moment().subtract(1, "months").endOf("month");
                break;
            case EMFOrderbookCalendarItems.THIS_QUARTER:
                startDate = moment().quarter(moment().quarter()).startOf("quarter");
                break;
            case EMFOrderbookCalendarItems.LAST_QUARTER:
                startDate = moment().subtract(1, "quarter").startOf("quarter");
                endDate = moment().subtract(1, "quarter").endOf("quarter");
                break;
            case EMFOrderbookCalendarItems.TILL_DATE:
                startDate = moment(inceptionDate);
                break;
            default:
                return;
        }
        handleApplyOnCalendarFilter(startDate.toDate(), endDate.toDate());
        setShowCalendarFilterPopup(false);
    };
    var handleSubGroupFilterSelection = function (startDate, endDate) {
        handleApplyOnCalendarFilter(startDate, endDate);
        setShowCalendarFilterPopup(false);
    };
    var handleApplyOnCalendarFilter = function (startDate, endDate) {
        getDisplayDate(startDate, endDate);
        var fromDate = moment(startDate).format("YYYY-MM-DD");
        var toDate = moment(endDate).format("YYYY-MM-DD");
        var updateFilters = __assign({}, props.filtersData);
        if (fromDate && toDate) {
            updateFilters.fromDate = fromDate;
            updateFilters.toDate = toDate;
        }
        Boolean(props === null || props === void 0 ? void 0 : props.handleFilterChangeCallback) &&
            props.handleFilterChangeCallback(updateFilters);
        Boolean(props === null || props === void 0 ? void 0 : props.handleApplyCallback) &&
            props.handleApplyCallback(updateFilters);
    };
    var getDisplayDate = function (startDate, endDate) {
        setDpDate("".concat(startDate === null || startDate === void 0 ? void 0 : startDate.getDate(), " ").concat(months[startDate === null || startDate === void 0 ? void 0 : startDate.getMonth()], " ").concat((startDate === null || startDate === void 0 ? void 0 : startDate.getFullYear()) % 100, " to ").concat(endDate === null || endDate === void 0 ? void 0 : endDate.getDate(), " ").concat(months[endDate === null || endDate === void 0 ? void 0 : endDate.getMonth()], " ").concat((endDate === null || endDate === void 0 ? void 0 : endDate.getFullYear()) % 100));
    };
    useEffect(function () {
        var _a, _b, _c, _d;
        if (((_a = props.filtersData) === null || _a === void 0 ? void 0 : _a.fromDate) && ((_b = props.filtersData) === null || _b === void 0 ? void 0 : _b.toDate)) {
            var startDate = new Date(Date.parse(props.filtersData.fromDate));
            var endDate = new Date(Date.parse(props.filtersData.toDate));
            getDisplayDate(startDate, endDate);
        }
        if (moment((_c = props.filtersData) === null || _c === void 0 ? void 0 : _c.fromDate).isSame(moment().startOf("month"), "day") &&
            moment((_d = props.filtersData) === null || _d === void 0 ? void 0 : _d.toDate).isSame(moment(), "day"))
            setSelectedFilter(EMFOrderbookCalendarItems.THIS_MONTH);
    }, [(_a = props === null || props === void 0 ? void 0 : props.filtersData) === null || _a === void 0 ? void 0 : _a.fromDate, (_b = props === null || props === void 0 ? void 0 : props.filtersData) === null || _b === void 0 ? void 0 : _b.toDate]);
    useEffect(function () {
        var _a;
        if (showCalendarFilterPopup) {
            document.body.style.overflow = "hidden";
            (_a = document === null || document === void 0 ? void 0 : document.querySelector(".primary-layout-hoc-container")) === null || _a === void 0 ? void 0 : _a.scroll({ top: 250, behavior: "smooth" });
        }
        else {
            document.body.style.overflow = "hidden";
        }
    }, [showCalendarFilterPopup]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "primary-calendar-filter-container hand_cursor position-relative", id: uniqueCalendarFilterId },
            React.createElement(GenericPopup, { children: React.createElement("div", { className: "calendar-filter-popup" },
                    React.createElement("div", { className: "DMSanN_15_400 d-flex align-items-center padding-15 header" }, "Date Range"),
                    React.createElement("div", { className: "d-flex flex-row" },
                        React.createElement("ul", null, Object.values(EMFOrderbookCalendarItems).map(function (item) {
                            return (React.createElement("li", { onClick: function () { return handleClickOnCalendarFilter(item); } },
                                React.createElement("div", { className: "DMsanR_12_300 d-flex align-items-center justify-content-between px-16 py-12 txt-grey-shade1 calendar-filter-popup-item ".concat(selectedFilter === item ? "selected" : "") },
                                    item,
                                    subGroups[item].length > 0 &&
                                        subGroupsList.length <= 0 ? (React.createElement("i", { className: "edel-icon-arrow-right1" })) : (""))));
                        })),
                        subGroupsList.length > 0 ? (React.createElement("ul", { className: "calendar-filter-subGroups" }, subGroupsList.map(function (item) {
                            return (React.createElement("li", { onClick: function () {
                                    return handleSubGroupFilterSelection(item.start, item.end);
                                } },
                                React.createElement("div", { className: "DMsanR_12_300 d-flex align-items-center justify-content-between px-16 py-12 txt-grey-shade1 calendar-filter-subgroup-item" }, item.label)));
                        }))) : (""))), placement: "bottom-end", button: React.createElement("div", { className: "orderbook-calendar-filters bg_white d-flex align-items-center gap-2 ".concat(showCalendarFilterPopup ? "active" : "") },
                    React.createElement("label", { className: "RobotoR_14_400 txt-midnight-blue hand_cursor" }, dpDate),
                    React.createElement("i", { className: "edel-icon-calendar-rounded" })), parentClass: "calendar-filter", buttonOnClick: function () { return setShowCalendarFilterPopup(true); }, isShow: showCalendarFilterPopup, setIsShow: setShowCalendarFilterPopup, containerDom: document.getElementById(uniqueCalendarFilterId), isHeadline: true, removeTooltipArrow: true, rootCloseEvent: "mousedown", flip: true })),
        showCustomCalendar ? (React.createElement(GenericDateSelectorModal, { title: "Custom Date Range", onApplyClick: handleApplyOnCustomCalendar, onCancelClick: function () { return setShowCustomCalendar(false); }, inceptionDate: inceptionDate, isRangeSelector: true })) : ("")));
};
export default MFOrderbookCalendarFilter;
